var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 640,
    height: 480,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0l640 480m0-480L0 480",
    stroke: "#FFF",
    strokeWidth: 96
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M0 0l640 480m0-480L0 480",
    stroke: "#C8102E",
    strokeWidth: 64
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M320 0v480M0 240h640",
    stroke: "#FFF",
    strokeWidth: 160
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    d: "M320 0v480M0 240h640",
    stroke: "#C8102E",
    strokeWidth: 96
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGb);
export default __webpack_public_path__ + "static/media/gb.2ab47b227a76d6292e1866eadd9246d6.svg";
export { ForwardRef as ReactComponent };